// extracted by css-extract-rspack-plugin
export default {"panel":"Panel__panel--Iq8Nd","head":"Panel__head--n0nkt","body":"Panel__body--xf4uL"};